<template>
    <div class="uuid-field">
        <div class="row">
            <div class="col-lg-10">
                <input
                    type="text"
                    :value="displayValue"
                    class="form-control"
                    :class="{ 'is-invalid': hasError }"
                    :placeholder="placeholder"
                    :disabled="true"
                    readonly
                />
                <div v-if="helpText" class="form-text text-muted">
                    {{ helpText }}
                </div>
                <div v-if="hasError" class="invalid-feedback">
                    {{ errorMessage }}
                </div>
            </div>
            <div class="col-lg-2">
                <button 
                    type="button" 
                    @click="copyToClipboard" 
                    class="btn btn-link btn-refresh"
                    :title="copyButtonTitle"
                    :disabled="!displayValue"
                >
                    <i class="fa fa-copy"></i>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import Uuid from './Uuid.js';

export default {
    ...Uuid
};
</script>

<style scoped>
.uuid-field {
    width: 100%;
    position: relative;
}

/* Add any custom styles here */
</style>
